import { render, staticRenderFns } from "./DialogFrame.vue?vue&type=template&id=10999ff0&scoped=true"
import script from "./DialogFrame.vue?vue&type=script&lang=js"
export * from "./DialogFrame.vue?vue&type=script&lang=js"
import style0 from "./DialogFrame.vue?vue&type=style&index=0&id=10999ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10999ff0",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fdialog-frame%2FDialogFrame.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports